"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_fall__detection__emergency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "62b9ef02-5fd0-48cd-8ecd-fab858877b1b",
    "data-name": "2b4a6ccb-d0bf-4a99-a685-840199261327",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "fall-detection-emergency-mid-v2"), /*#__PURE__*/React.createElement("g", {
    id: "0ccaa9e5-ebab-4bf9-a686-0223997f1537",
    "data-name": "12053d83-1885-46e3-8d65-5e670ed25ae9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "afe747c6-d05c-4b3d-ae1d-4a8dab9aac09",
    "data-name": "d1756696-d7ec-4512-908d-1f061a1ef18c",
    cx: 136.15,
    cy: 43.94,
    r: 18,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.83,165.87a11,11,0,0,1-4.93-1.17,11.27,11.27,0,0,1-5.23-14.07L68.51,125a11,11,0,0,1,6.39-6.34l8.31-3.14-13.14-4.64L50.7,122.76a11,11,0,0,1-11.38-18.83h0L63.15,89.38a11,11,0,0,1,9.35-.95l17.67,5.82,8-15.93a.45.45,0,0,0-.17-.61L84.1,70.15a9.74,9.74,0,0,1-5-7.27L75.82,37a9.68,9.68,0,0,1,8.35-10.83h0a8.65,8.65,0,0,1,1.25-.08A9.7,9.7,0,0,1,95,34.54l2.6,20.18a1.42,1.42,0,0,0,.76,1.07l35.05,15.92a8.1,8.1,0,0,1,3.16,2.23l18.82,20.3a9.74,9.74,0,0,1,2.24,9.2l-6.83,24c-1.17,4.16-4.19,8-8.51,8a9.69,9.69,0,0,1-9.63-9.75,9.52,9.52,0,0,1,.34-2.49l5-17.58a2.21,2.21,0,0,0-.51-2.1l-6.5-7-10.81,24.27c-2,3.42-4.42,6-7.64,7.18l-24.41,9.22A2,2,0,0,0,87,138.38l-7.9,20.44A11.06,11.06,0,0,1,68.83,165.87Z",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })));
}

var _default = ic_fall__detection__emergency;
exports.default = _default;